import { buildCareerStatTiles } from "../../../../domain/player/playerIntelligence";
import styles from "../../styles/playerEcosystem.module.css";

/**
 * Reusable career statistic cards (Player Intelligence).
 * @param {{ stats?: object, tiles?: Array<{ label: string, value: string | number }> }} props
 */
export default function CareerStatsCards({ stats, tiles: tilesProp }) {
  const tiles = tilesProp?.length ? tilesProp : buildCareerStatTiles(stats);
  if (!tiles.length) return null;
  return (
    <div className={styles.statsGrid} aria-label="Career statistics">
      {tiles.map((t) => (
        <article key={t.label} className={styles.statCard}>
          <p className={styles.statLabel}>{t.label}</p>
          <p className={styles.statValue}>{t.value}</p>
        </article>
      ))}
    </div>
  );
}
